module.exports = __webpack_public_path__ + "static/media/SWIMMING_POOL_SIAMESE.b0b99276.png";